import { PRODUCT_PAGES } from '@core/api/constants/pages.constants';
import { isPathAvailableWithTranslations } from '@core/handlers/utils.handlers';
import { availableDeveloperRoutes, availableResourcesRoutes } from '@layout/nav/db/header.db';
import { EnFlatMenuItemType, EnMenuItemType } from '@layout/nav/enums/nav.enum';
import { ISimple } from '@noda-lib/utils/interfaces';
import { parsePath } from '@translate/utils/parse-lang-path';

function removeQueryParams(link: string, queryParams: string): string {
  return link?.replace(queryParams, '');
}

function parseLink(link: string, queryParams: string): { cleanPath: string; parentRoute: string } {
  const { cleanPath: path, parentRoute: route } = parsePath(link);

  const cleanPath: string = removeQueryParams(path, queryParams);
  const parentRoute: string = removeQueryParams(route, queryParams);

  return { cleanPath, parentRoute };
}

export function isCurrentLink(label: string, currentLink: string, queryParams: string): boolean {
  const { cleanPath, parentRoute } = parseLink(currentLink, queryParams);

  const labelConditions: ISimple<boolean> = {
    [EnMenuItemType.Products]: isPathAvailableWithTranslations(PRODUCT_PAGES, cleanPath),
    [EnMenuItemType.UseCases]: parentRoute === 'use-cases',
    [EnMenuItemType.About]: parentRoute === 'about',
    [EnMenuItemType.Developers]: availableDeveloperRoutes.includes(`/${parentRoute}`),
    [EnFlatMenuItemType.Pricing]: parentRoute === 'pricing',
    [EnFlatMenuItemType.Marketplace]: parentRoute === 'marketplace',
    [EnMenuItemType.Resources]: availableResourcesRoutes.includes(`/${parentRoute}`),
    [EnFlatMenuItemType.ContactUs]: parentRoute === 'contact-us',
  };

  return labelConditions[label];
}
